import { styled } from '@mui/material/styles';

import { Button } from '@openx/components-core/lib/Button/Button.tsx';

export const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.spacing(2.1)};
`;
